<form [formGroup]="changePasswordForm" (ngSubmit)="changePassword(formDirective)" class="form form--password" #formDirective="ngForm">
  <div class="row">
    <div class="col">
      <mat-form-field appearance="outline" class="wm-input">
        <input formControlName="currentPassword" matInput [placeholder]="'WM_TECH_POOL.SETTINGS.CURRENT_PASSWORD' | translate" [type]="hidePassword1 ? 'password' : 'text'" />
        <button mat-icon-button matSuffix type="button" (click)="hidePassword1 = !hidePassword1" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword1">
          <mat-icon>{{ hidePassword1 ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="col">
      <mat-form-field appearance="outline" class="wm-input">
        <input formControlName="password" matInput [placeholder]="'WM_TECH_POOL.SETTINGS.NEW_PASSWORD' | translate" [type]="hidePassword2 ? 'password' : 'text'" />
        <button mat-icon-button matSuffix type="button" (click)="hidePassword2 = !hidePassword2" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword2">
          <mat-icon>{{ hidePassword2 ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="col">
      <mat-form-field appearance="outline" class="wm-input">
        <input formControlName="confirmPassword" matInput [placeholder]="'WM_TECH_POOL.SETTINGS.CONFIRM_NEW_PASSWORD' | translate" [type]="hidePassword3 ? 'password' : 'text'" />
        <button mat-icon-button matSuffix type="button" (click)="hidePassword3 = !hidePassword3" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword3">
          <mat-icon>{{ hidePassword3 ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>
      <p class="mat-caption opacity-text" style="visibility: hidden">.</p>
    </div>
  </div>

  <button mat-raised-button color="tech-button-bg-primary" type="submit" class="submit-button" [disabled]="changePasswordForm.invalid">
    {{ 'WM_TECH_POOL.SETTINGS.CHANGE_PASSWORD' | translate }}
  </button>
</form>
